import initData from 'init-data';

const isEnabled = (key) => {
    return (
        initData && initData.featureSwitches && initData.featureSwitches[key]
    );
};

export const errors = {
    ELASTIC_MYTRADERA:
        'Just nu har vi driftstörningar på delar av Mitt Tradera. Vi arbetar på att lösa problemet.'
};

// ATTENTION!
// Do not any more dependencies to initData.featureSwitches!
// Feature switches MUST be read from Redux.
// The functions below must only be used in MyTradera and the only
// reason they are still here is because it requires large changes
// to MyTradera to get rid of them.
export default {
    isMyTraderaElasticEnabled: isEnabled('mytradera-elasticsearch'),
    isMessagingEnabled: isEnabled('messaging'),
    isPennybridgeCharitiesEnabled: isEnabled('pennybridge-charities'),
    isDiscontinuedSaleEnabled: isEnabled('discontinued-sale'),
    isDiscontinuedSaleMessagingEnabled: isEnabled(
        'discontinued-sale-messaging'
    ),
    isDisputeV2AddEnabled: isEnabled('dispute-v2-add')
};
